(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62261,65250],{

/***/ 62261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CampLejeuneApplicationWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/styles/variables/camplejeuneapplicationVariables.module.scss
var camplejeuneapplicationVariables_module = __webpack_require__(4420);
var camplejeuneapplicationVariables_module_default = /*#__PURE__*/__webpack_require__.n(camplejeuneapplicationVariables_module);
;// CONCATENATED MODULE: ./src/components/camplejeuneapplication/logo/index.tsx


function CampLejeuneApplicationLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 211.63 40.44",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0.74H35.73V36.47H0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#222e59",
                        d: "M55.26 0a8 8 0 012.24.3 13.66 13.66 0 012 .78l.55.26a1.08 1.08 0 00.45.12c.29 0 .47-.17.57-.51 0-.08.07-.13.17-.17a.78.78 0 01.3 0 .82.82 0 01.25.07.14.14 0 01.09.16 4.45 4.45 0 00-.15.9v.94a11.09 11.09 0 00.1 1.52c.08.5.15 1 .22 1.56a.2.2 0 01-.12.18.82.82 0 01-.3.08.78.78 0 01-.34 0 .25.25 0 01-.18-.19 6.59 6.59 0 00-2.19-3.58 6.11 6.11 0 00-3.82-1.15 5.22 5.22 0 00-2.95.73 5.43 5.43 0 00-1.85 2 8.3 8.3 0 00-1 2.65 15.28 15.28 0 00-.27 2.82 14.18 14.18 0 00.32 3 9.12 9.12 0 001 2.73 6.26 6.26 0 001.91 2 5.1 5.1 0 002.85.77 11 11 0 002.33-.23 3.87 3.87 0 001.73-.86 6 6 0 001.38-1.87 9.47 9.47 0 00.73-2.48.26.26 0 01.17-.24.47.47 0 01.31 0 .69.69 0 01.3.14c.09.08.13.15.11.22a10 10 0 00-.11 1.07v1.07c0 .61 0 1.24.07 1.87s.09 1.32.12 2a.26.26 0 01-.11.24.43.43 0 01-.25.1.49.49 0 01-.29-.06.27.27 0 01-.16-.2 1.72 1.72 0 00-.19-.47 1.16 1.16 0 00-.35-.38.88.88 0 00-.51-.15 1.35 1.35 0 00-.63.19c-.39.21-.78.4-1.14.55a6.78 6.78 0 01-1.13.37 8.46 8.46 0 01-1.19.19C56 19 55.5 19 55 19q-4.78 0-7.09-2.39t-2.3-6.82a11.22 11.22 0 01.73-4.21 8.63 8.63 0 012-3.07 8.4 8.4 0 013-1.87A11.21 11.21 0 0155.26 0zM73.83 15.79a3.62 3.62 0 00.17 1.32.69.69 0 00.69.38 1.37 1.37 0 00.49-.07 3.14 3.14 0 00.54-.28.15.15 0 01.18 0 .45.45 0 01.16.15.67.67 0 01.09.21.22.22 0 01-.05.21A3.16 3.16 0 0173.61 19a2.16 2.16 0 01-1.34-.42 2.66 2.66 0 01-.82-1c0-.09-.09-.1-.16 0a6.08 6.08 0 01-1.64 1 5.88 5.88 0 01-2.34.41 3.25 3.25 0 01-2.38-.83 3.13 3.13 0 01-.83-2.34 3.26 3.26 0 011.81-3 10.65 10.65 0 015.27-1s.06 0 .08-.14a3.82 3.82 0 000-.62v-.76a7.32 7.32 0 00-.08-1.3 3.2 3.2 0 00-.37-1 1.84 1.84 0 00-.71-.7A2.24 2.24 0 0069 7a3 3 0 00-1.62.39 1.15 1.15 0 00-.62 1 1 1 0 00.19.59 1.05 1.05 0 01.19.58 1 1 0 01-.38.73 1.32 1.32 0 01-.92.35 1.24 1.24 0 01-1-.39 1.48 1.48 0 01-.31-1 2.36 2.36 0 01.3-1.25 3.48 3.48 0 011-1 5.45 5.45 0 011.52-.69 6.33 6.33 0 011.81-.25 5.26 5.26 0 013.4 1 4 4 0 011.25 3.32zm-2.54-2.68a1.18 1.18 0 000-.36c0-.05-.06-.07-.14-.07a7 7 0 00-3.28.93 2.32 2.32 0 00-.66 3.27 1.56 1.56 0 001.35.56 4.2 4.2 0 002.54-1 .64.64 0 00.22-.43zM81.59 15.44v1.13a1.8 1.8 0 00.19.76 1.1 1.1 0 00.53.46 3.48 3.48 0 001 .24.38.38 0 01.25.15.54.54 0 01.08.28.5.5 0 01-.08.26.29.29 0 01-.25.12 12.45 12.45 0 01-1.31-.09 12.17 12.17 0 00-1.6-.1 13.08 13.08 0 00-1.68.1 13.62 13.62 0 01-1.49.09.24.24 0 01-.21-.12.42.42 0 01-.08-.26.46.46 0 01.08-.28.34.34 0 01.24-.15 3.55 3.55 0 001-.24 1.13 1.13 0 00.53-.45 1.6 1.6 0 00.19-.7v-5-2a3.61 3.61 0 00-.19-1.16 1 1 0 00-.5-.56 3 3 0 00-1-.17.25.25 0 01-.21-.11.44.44 0 01-.08-.31.34.34 0 010-.26.24.24 0 01.29-.07c.3 0 .75-.11 1.34-.22s1.22-.25 1.9-.43a.71.71 0 01.22 0h.21a.6.6 0 01.46.22.69.69 0 01.17.51l-.06 1.22c0 .09 0 .1.11 0s.24-.32.45-.57A4.29 4.29 0 0182.9 7a5.3 5.3 0 011.21-.66 4.44 4.44 0 011.64-.28 4.66 4.66 0 012.65.66 4.23 4.23 0 011.51 2 3.3 3.3 0 01.52-.75 5.24 5.24 0 011-.86 6.4 6.4 0 011.35-.72 4.4 4.4 0 011.65-.29 4.91 4.91 0 012.11.39 3.19 3.19 0 011.27 1.07 4.15 4.15 0 01.62 1.6 11.73 11.73 0 01.16 2v5.43a2.21 2.21 0 00.16.76 1 1 0 00.43.46 2.54 2.54 0 00.87.24.34.34 0 01.24.15.46.46 0 01.08.28.42.42 0 01-.08.26.26.26 0 01-.24.12 10.52 10.52 0 01-1.11-.09 11.4 11.4 0 00-1.57-.1 12.76 12.76 0 00-1.66.1 12.72 12.72 0 01-1.42.09.26.26 0 01-.22-.12.5.5 0 01-.08-.26.54.54 0 01.08-.28.38.38 0 01.25-.15 3.09 3.09 0 001-.24 1.06 1.06 0 00.5-.45 1.48 1.48 0 00.19-.7v-4.55-1.51a5.33 5.33 0 00-.29-1.44A2.51 2.51 0 0095 8.1a1.84 1.84 0 00-1.29-.42 2.9 2.9 0 00-1.43.32 4 4 0 00-1.15.89 4.28 4.28 0 00-.77 1.18 3 3 0 00-.29 1.23v5.36a2 2 0 00.16.75.81.81 0 00.44.39 3.53 3.53 0 00.86.2.34.34 0 01.24.15.47.47 0 01.09.28.43.43 0 01-.09.26.26.26 0 01-.24.12 10.72 10.72 0 01-1.11-.09 11.4 11.4 0 00-1.57-.1 12.76 12.76 0 00-1.66.1 12.3 12.3 0 01-1.34.09.24.24 0 01-.21-.12.42.42 0 01-.08-.26.46.46 0 01.08-.28.34.34 0 01.24-.15 4.42 4.42 0 00.93-.2.88.88 0 00.49-.38 1.58 1.58 0 00.18-.69v-4.62c0-.49 0-1-.06-1.51a5.33 5.33 0 00-.32-1.44 2.49 2.49 0 00-.73-1.06 2 2 0 00-1.35-.42 3.38 3.38 0 00-1.53.32 3.1 3.1 0 00-1.08.87 3.66 3.66 0 00-.62 1.21 4.3 4.3 0 00-.2 1.31z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#222e59",
                        d: "M102 12.19v-2.2a5.16 5.16 0 00-.21-1.39 1.35 1.35 0 00-.57-.75 2.31 2.31 0 00-1.09-.25.24.24 0 01-.21-.14.66.66 0 01-.06-.27.65.65 0 010-.27.17.17 0 01.16-.13l1.57-.18a16.19 16.19 0 001.89-.34 1.11 1.11 0 01.58 0c.14.06.22.21.26.46l.11 1.43c0 .06 0 .07.08 0a4.48 4.48 0 011.5-1.5 4.78 4.78 0 014.5-.13 4.5 4.5 0 011.53 1.35 6.33 6.33 0 01.92 2 8.9 8.9 0 01-.1 5 6.59 6.59 0 01-1.13 2.12 5.34 5.34 0 01-1.81 1.43 5.27 5.27 0 01-2.38.52 8.32 8.32 0 01-1.49-.12 12.28 12.28 0 01-1.29-.34h-.17a.76.76 0 000 .27v6.12a1.25 1.25 0 00.93 1.22 6.87 6.87 0 001.32.24.3.3 0 01.23.15.45.45 0 01.07.25.55.55 0 01-.08.29.25.25 0 01-.22.12 17.59 17.59 0 01-2-.09 11.67 11.67 0 00-1.56-.1 13.28 13.28 0 00-1.65.1 15.85 15.85 0 01-1.7.09.26.26 0 01-.22-.12.55.55 0 01-.08-.29.46.46 0 01.08-.25.38.38 0 01.25-.15 5.62 5.62 0 001.17-.24 1.22 1.22 0 00.61-.45A1.38 1.38 0 00102 25v-3.59zm2.55 3.57a1.32 1.32 0 00.19.58 2.49 2.49 0 00.55.7 3.47 3.47 0 00.89.6 2.71 2.71 0 001.2.26 2.29 2.29 0 001.42-.44 3.08 3.08 0 001-1.19 6.54 6.54 0 00.53-1.75 13 13 0 00.16-2.11 7.56 7.56 0 00-.65-3.41 2.19 2.19 0 00-2.08-1.15 3.57 3.57 0 00-1.29.23 3.41 3.41 0 00-1 .6 2.64 2.64 0 00-.66.86 2.34 2.34 0 00-.24 1zM120.72 4.6a9.88 9.88 0 00-.09-1.44 2.24 2.24 0 00-.37-1 1.65 1.65 0 00-.77-.58 4.34 4.34 0 00-1.33-.26.27.27 0 01-.25-.15.68.68 0 01-.08-.31.64.64 0 01.08-.3.28.28 0 01.25-.13c.57 0 1.23 0 2 .08s1.43.08 2.08.08H124.31l1-.05h1.06a.25.25 0 01.23.13.61.61 0 010 .3.71.71 0 01-.1.31.23.23 0 01-.21.15 5.35 5.35 0 00-1.35.23 1.6 1.6 0 00-.79.54 2.19 2.19 0 00-.35 1 12.43 12.43 0 00-.08 1.52V14a11.54 11.54 0 00.08 1.45 2.77 2.77 0 00.3 1 1.51 1.51 0 00.59.61 4.81 4.81 0 001 .38c.25.05.54.09.85.12s.65 0 1 0 .84 0 1.21-.05a4.13 4.13 0 00.87-.16 6.94 6.94 0 00.93-.41 2 2 0 00.66-.57 3 3 0 00.45-.88 6.94 6.94 0 00.28-1.33.28.28 0 01.06-.16 1 1 0 01.36 0 .62.62 0 01.33.08.18.18 0 01.12.21c-.09.76-.17 1.47-.24 2.12a15 15 0 00-.08 2 .5.5 0 01-.11.23q-.1.15-.51.15h-9.81c-.71 0-1.38 0-2 .06l-1.92.13a.31.31 0 01-.28-.14.47.47 0 01-.1-.3.54.54 0 01.1-.31.36.36 0 01.28-.17c.56-.08 1-.15 1.35-.23a1.68 1.68 0 00.78-.38 1.33 1.33 0 00.37-.76 8.29 8.29 0 00.09-1.39V4.6zM137.56 11.81c-.09 0-.14 0-.14.1a1.4 1.4 0 000 .23 8.18 8.18 0 00.31 2.38 4.27 4.27 0 00.87 1.58 3.27 3.27 0 001.32.88 5 5 0 001.67.27 10.43 10.43 0 001.78-.15 3.17 3.17 0 001.49-.66.34.34 0 01.28-.09.42.42 0 01.24.14.47.47 0 01.13.24.32.32 0 01-.06.25 4.59 4.59 0 01-2 1.56 7.17 7.17 0 01-2.67.44 7.38 7.38 0 01-2.8-.49 5.27 5.27 0 01-1.95-1.36 5.67 5.67 0 01-1.13-2.06 8.63 8.63 0 01-.37-2.55A7.08 7.08 0 01135 10a6.06 6.06 0 013.18-3.43 5.82 5.82 0 012.46-.51 5.29 5.29 0 012.06.39 4.57 4.57 0 011.59 1.08 4.92 4.92 0 011 1.65 5.85 5.85 0 01.36 2.07c0 .37-.13.56-.4.56zm4.95-.94c.25 0 .4-.09.43-.27a3.06 3.06 0 00.06-.6 3.38 3.38 0 00-.18-1.1 2.78 2.78 0 00-.5-.93 2.34 2.34 0 00-.78-.65 2.27 2.27 0 00-1.06-.32 2.74 2.74 0 00-2.14.93 2.83 2.83 0 00-.56 1 5.73 5.73 0 00-.27 1.19 2.05 2.05 0 000 .52q0 .21.12.21zM151.84 21.91a4.85 4.85 0 01-.22 1.36 4.35 4.35 0 01-.71 1.45 3.95 3.95 0 01-3.37 1.59 3.91 3.91 0 01-1.24-.17 3.75 3.75 0 01-.92-.43 2 2 0 01-.58-.58 1.22 1.22 0 01-.21-.65 1.57 1.57 0 01.37-1 1.18 1.18 0 011-.43 1.33 1.33 0 01.9.28.89.89 0 01.34.72.76.76 0 01-.16.51.61.61 0 00-.16.41.73.73 0 00.09.35c.06.11.3.16.72.16a1.66 1.66 0 00.93-.23 1.3 1.3 0 00.5-.69 3.89 3.89 0 00.19-1.12V11.22c0-.78 0-1.38-.06-1.83a2.38 2.38 0 00-.25-1 1 1 0 00-.63-.44 8.34 8.34 0 00-1.14-.19.24.24 0 01-.21-.14.92.92 0 01-.08-.27.45.45 0 01.06-.27.23.23 0 01.23-.13c.41 0 .93-.11 1.56-.2s1.26-.23 1.87-.37l.4-.11a2 2 0 01.33 0 .37.37 0 01.35.19.68.68 0 01.11.32zm-1.6-18.48a1.73 1.73 0 01-1.16-.43 1.31 1.31 0 01-.49-1 1.41 1.41 0 01.45-1 1.54 1.54 0 011.12-.43 1.48 1.48 0 011.12.43 1.46 1.46 0 01.42 1 1.43 1.43 0 01-.42 1 1.37 1.37 0 01-1.04.43zM158.46 11.81c-.09 0-.14 0-.15.1a1.55 1.55 0 000 .23 7.85 7.85 0 00.31 2.38 4.27 4.27 0 00.87 1.58 3.2 3.2 0 001.32.88 5 5 0 001.66.27 10.55 10.55 0 001.79-.15 3.13 3.13 0 001.48-.66.36.36 0 01.29-.09.42.42 0 01.24.14.55.55 0 01.12.24.31.31 0 010 .25 4.65 4.65 0 01-2 1.56 7.17 7.17 0 01-2.67.44 7.34 7.34 0 01-2.8-.49 5.11 5.11 0 01-1.92-1.36 5.67 5.67 0 01-1.13-2.06 8.32 8.32 0 01-.37-2.55 7.08 7.08 0 01.45-2.52 5.92 5.92 0 011.25-2 6 6 0 011.92-1.38 5.82 5.82 0 012.46-.51 5.3 5.3 0 012.07.39 4.53 4.53 0 011.58 1.08 4.94 4.94 0 011 1.65 5.85 5.85 0 01.36 2.07c0 .37-.13.56-.4.56zm4.95-.94c.25 0 .39-.09.43-.27a3.06 3.06 0 00.06-.65 3.38 3.38 0 00-.18-1.1 3 3 0 00-.5-.93 2.56 2.56 0 00-.78-.65 2.27 2.27 0 00-1.06-.27 2.75 2.75 0 00-1.26.26A2.7 2.7 0 00158.68 9a5.73 5.73 0 00-.27 1.19 2.05 2.05 0 000 .52q0 .21.12.21zM181 14v1.8a2.7 2.7 0 00.24 1.08 1.11 1.11 0 00.61.54 3.39 3.39 0 001.13.15.2.2 0 01.18.12.65.65 0 01.07.29.66.66 0 01-.06.27.18.18 0 01-.19.13H182l-.45.06c-.14 0-.35.05-.61.11l-.79.16-.76.13-.39.16c-.33 0-.49-.51-.49-1.52a.06.06 0 00-.05-.06.11.11 0 00-.11 0 6.29 6.29 0 01-2 1.2 6.37 6.37 0 01-2 .34 6 6 0 01-2.06-.31 2.87 2.87 0 01-1.27-.91 3.81 3.81 0 01-.65-1.47 10 10 0 01-.19-2v-3.02c0-.78 0-1.38-.05-1.82a2.57 2.57 0 00-.24-1 .92.92 0 00-.57-.43 6.89 6.89 0 00-1-.19.21.21 0 01-.2-.14.7.7 0 01-.08-.27.52.52 0 010-.27.24.24 0 01.26-.13h.7c.3 0 .62-.09 1-.16l1-.28 1.05-.26q.38-.1.51.12a.78.78 0 01.13.39v6.44a15.46 15.46 0 00.1 1.83 3.89 3.89 0 00.34 1.25 1.47 1.47 0 00.67.7 2.47 2.47 0 001.08.22 6.06 6.06 0 001.92-.33 4.06 4.06 0 001.52-.78.51.51 0 00.09-.3v-4.59-1.82a2.5 2.5 0 00-.19-1 .82.82 0 00-.5-.43 5.6 5.6 0 00-1-.19.28.28 0 01-.2-.15.77.77 0 01-.08-.27.49.49 0 01.05-.27.25.25 0 01.23-.12 11.58 11.58 0 001.79-.24c.54-.13 1.14-.29 1.81-.49q.38-.1.51.12a.81.81 0 01.14.39zM188.74 15.44v1.13a2.24 2.24 0 00.14.76.92.92 0 00.41.46 2.23 2.23 0 00.8.24.34.34 0 01.24.15.54.54 0 01.08.28.5.5 0 01-.08.26.26.26 0 01-.24.12q-.27 0-1-.09a11 11 0 00-1.55-.1 13.08 13.08 0 00-1.68.1 13.68 13.68 0 01-1.51.09.26.26 0 01-.22-.12.5.5 0 01-.08-.26.54.54 0 01.08-.28.38.38 0 01.25-.15 5.35 5.35 0 001-.21 1.15 1.15 0 00.54-.41 1.56 1.56 0 00.2-.7V12.19v-2.2A5.27 5.27 0 00186 8.6a1.22 1.22 0 00-.51-.72 2.11 2.11 0 00-1-.2.33.33 0 01-.26-.11.36.36 0 01-.09-.24.4.4 0 01.09-.27.3.3 0 01.26-.11 11.28 11.28 0 001.5-.16 19.89 19.89 0 002-.46.47.47 0 01.57.14 1 1 0 01.19.59V8.2h.07a4.82 4.82 0 011.33-1.35 5.64 5.64 0 011.07-.54 4 4 0 011.33-.21 4.32 4.32 0 013.17 1.12 4.9 4.9 0 011.15 3.63v5.82a2 2 0 00.19.74 1 1 0 00.46.43 3 3 0 00.88.23.34.34 0 01.24.15.46.46 0 01.08.28.42.42 0 01-.08.26.26.26 0 01-.24.12c-.23 0-.62 0-1.15-.09a12.32 12.32 0 00-1.61-.1 12.61 12.61 0 00-1.65.1 11.65 11.65 0 01-1.29.09.25.25 0 01-.22-.12.5.5 0 01-.08-.26.54.54 0 01.08-.28.36.36 0 01.24-.15 2.74 2.74 0 00.91-.24 1.05 1.05 0 00.46-.45 1.6 1.6 0 00.17-.7v-5.19c0-.45 0-.9-.05-1.35a3.83 3.83 0 00-.3-1.22 2.28 2.28 0 00-.7-.89 2 2 0 00-1.21-.35 3.64 3.64 0 00-1.42.25 3.32 3.32 0 00-1 .69 3 3 0 00-.64 1 3.57 3.57 0 00-.21 1.23zM203.52 11.81c-.09 0-.14 0-.14.1a1.4 1.4 0 000 .23 8.18 8.18 0 00.31 2.38 4.27 4.27 0 00.87 1.58 3.27 3.27 0 001.32.88 5 5 0 001.67.27 10.43 10.43 0 001.78-.15 3.17 3.17 0 001.49-.66.34.34 0 01.28-.09.42.42 0 01.24.14.47.47 0 01.13.24.32.32 0 01-.06.25 4.62 4.62 0 01-1.94 1.56 7.26 7.26 0 01-2.68.44 7.38 7.38 0 01-2.8-.49 5.27 5.27 0 01-1.99-1.36 5.67 5.67 0 01-1.13-2.06 8.63 8.63 0 01-.37-2.55A7.08 7.08 0 01201 10a6.06 6.06 0 013.18-3.43 5.79 5.79 0 012.46-.51 5.29 5.29 0 012.06.39 4.57 4.57 0 011.59 1.08 4.92 4.92 0 011 1.65 5.85 5.85 0 01.36 2.07c0 .37-.13.56-.4.56zm4.95-.94c.25 0 .4-.09.43-.27a3.06 3.06 0 00.1-.6 3.38 3.38 0 00-.18-1.1 2.78 2.78 0 00-.5-.93 2.34 2.34 0 00-.78-.65 2.27 2.27 0 00-1.1-.32 2.74 2.74 0 00-2.14 1 2.83 2.83 0 00-.56 1 5.73 5.73 0 00-.27 1.19 2.05 2.05 0 000 .52q0 .21.12.21z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#999",
                        d: "M54.33 37.52h-1.44L51.9 35h-3.71l-1 2.54h-1.43l4-9.76h.72zm-2.87-3.78l-1.4-3.68-1.42 3.68zM61.65 30.27a3.3 3.3 0 012.52 1.08 3.91 3.91 0 010 5.27 3.33 3.33 0 01-2.53 1.07 3.07 3.07 0 01-2.51-1.2v3.95h-1.27v-10h1.27v1.07a3.08 3.08 0 012.52-1.24zM63.92 34a2.54 2.54 0 00-.67-1.8 2.29 2.29 0 00-1.76-.74 2.25 2.25 0 00-1.75.74 2.56 2.56 0 00-.67 1.8 2.59 2.59 0 00.67 1.82 2.25 2.25 0 001.75.74 2.29 2.29 0 001.76-.74 2.56 2.56 0 00.67-1.82zM72.87 30.27a3.3 3.3 0 012.53 1.08 3.94 3.94 0 010 5.27 3.35 3.35 0 01-2.54 1.07 3.07 3.07 0 01-2.51-1.2v3.95h-1.27v-10h1.27v1.07a3.08 3.08 0 012.52-1.24zM75.15 34a2.55 2.55 0 00-.68-1.8 2.45 2.45 0 00-3.51 0 2.6 2.6 0 00-.66 1.8 2.63 2.63 0 00.7 1.79 2.45 2.45 0 003.51 0 2.57 2.57 0 00.64-1.79zM81.58 27.52v10h-1.27v-10zM86.58 29.44a.93.93 0 01-.66-.26.85.85 0 01-.26-.65.83.83 0 01.26-.64 1 1 0 01.66-.25.9.9 0 01.64.26.86.86 0 01.26.63.89.89 0 01-.26.65.9.9 0 01-.64.26zm.61 1v7.08h-1.27v-7.08zM94.83 37.68a3.76 3.76 0 01-2.68-6.37 3.77 3.77 0 012.75-1 3.82 3.82 0 011.92.5 3 3 0 011.29 1.35l-1 .61a2.68 2.68 0 00-.93-1 2.49 2.49 0 00-1.24-.34 2.45 2.45 0 00-1.81.73 2.69 2.69 0 000 3.63 2.32 2.32 0 001.75.73 2.51 2.51 0 001.28-.36 2.44 2.44 0 00.92-.91l1 .6a3.31 3.31 0 01-1.32 1.33 3.94 3.94 0 01-1.93.5zM107.42 31.47v-1h1.21v7.08h-1.21v-1a3.06 3.06 0 01-2.5 1.17 3.3 3.3 0 01-2.53-1.08 3.8 3.8 0 01-1-2.68 3.57 3.57 0 011-2.62 3.38 3.38 0 012.53-1 3.1 3.1 0 012.5 1.13zm.08 2.5a2.59 2.59 0 00-.67-1.8 2.29 2.29 0 00-1.76-.74 2.23 2.23 0 00-1.74.74 2.81 2.81 0 000 3.62 2.23 2.23 0 001.74.74 2.29 2.29 0 001.76-.74 2.6 2.6 0 00.67-1.79zM117.13 36.12l.47 1a3 3 0 01-1.89.59A2.05 2.05 0 01114 37a3 3 0 01-.58-2v-3.48h-1.22v-1.08h1.27v-2.51h1.24v2.51h2.51v1.08h-2.51v3.61c0 .93.38 1.4 1.15 1.4a2.43 2.43 0 001.27-.41zM121.65 29.44a.93.93 0 01-.66-.26.89.89 0 01-.26-.65.87.87 0 01.26-.64 1 1 0 01.66-.25.9.9 0 01.64.26.86.86 0 01.26.63.89.89 0 01-.26.65.9.9 0 01-.64.26zm.61 1v7.08H121v-7.08zM129.89 37.69a3.63 3.63 0 01-2.68-1.07 3.7 3.7 0 01-1-2.65 3.62 3.62 0 013.72-3.71 3.54 3.54 0 012.66 1.08 3.84 3.84 0 010 5.28 3.6 3.6 0 01-2.7 1.07zm2.45-3.69a2.48 2.48 0 00-.72-1.79 2.29 2.29 0 00-1.73-.75 2.32 2.32 0 00-1.73.75 2.52 2.52 0 00-.71 1.79 2.58 2.58 0 00.71 1.81 2.32 2.32 0 001.73.75 2.29 2.29 0 001.73-.75 2.55 2.55 0 00.72-1.81zM138.77 37.52h-1.27v-7.08h1.24v1a2.38 2.38 0 012.26-1.18 2.78 2.78 0 012 .76 2.9 2.9 0 01.81 2.21v4.29h-1.26v-3.94A2.34 2.34 0 00142 32a1.66 1.66 0 00-1.32-.57 1.81 1.81 0 00-1.41.61 2.28 2.28 0 00-.54 1.56z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#c1312c",
                        d: "M13.81 36.47h21.91v-4.58a143 143 0 00-15.4 2.56 35.71 35.71 0 00-6.51 2zM0 24.79v5a37.71 37.71 0 0120.32-11.91c8.63-1.77 13.15-3.55 15.4-4.71V6.61c-3 2.13-8.37 5-16.83 6.76A32.21 32.21 0 000 24.79zM0 35.77v.7h4.69A36.83 36.83 0 0120.32 29a143 143 0 0115.4-2.56v-5.86c-2.25.51-6.77 1.5-15.4 3.27A37.71 37.71 0 000 35.77z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#222e59",
                        d: "M25.39 5l-1.25-.25-.92.89-.15-1.27-1.13-.6 1.16-.53.22-1.24.87.94 1.26-.18-.62 1.11.56 1.13zm-4.45 1.24L19.69 6l-.92.89-.15-1.27L17.49 5l1.16-.53.22-1.26.87.94L21 4l-.63 1.12.56 1.15zm-4.56 1L15.13 7l-.92.89-.15-1.29-1.13-.6 1.16-.53.22-1.27.87 1 1.27-.2-.63 1.12.56 1.15zm-4 2.23l-1.26-.25-.92.89-.2-1.28-1.13-.6 1.17-.53.21-1.26.87.94 1.27-.19-.63 1.12.57 1.15zM7.56 7l-.91.89L6.5 6.6 5.36 6l1.17-.53.22-1.27.86 1L8.88 5l-.62 1.08.56 1.15L7.56 7zm.89 4.71l-1.26-.25-.92.89-.15-1.27L5 10.46l1.17-.53.21-1.26.87.94 1.27-.18-.63 1.11.57 1.15zm-4.54-7.6l.57 1.15L3.22 5l-.92.9-.15-1.27L1 4l1.19-.5.22-1.26.86.94L4.54 3l-.63 1.11zm0 4.45l.57 1.15-1.26-.25-.92.89-.15-1.27L1 8.48l1.17-.54.22-1.26.86.94 1.27-.18-.61 1.12zm.57 5.67L3.22 14l-.92.89-.15-1.29L1 13l1.17-.53.22-1.26.86.94L4.54 12l-.63 1.11.57 1.15zm6.41-10.7l.22-1.26.87.94L13.25 3l-.63 1.11.57 1.15L11.93 5l-.93.93-.15-1.27-1.13-.6 1.16-.53zM28.15.74l.84.91 1.27-.18-.63 1.11.56 1.15-1.25-.25-.94.89-.13-1.27-1.13-.6L27.9 2l.21-1.26H21.8l-.21.38.56 1.15L20.9 2l-.9.91-.15-1.27L18.7 1l.64-.3h-3.7l.58.64 1.27-.19-.63 1.12.57 1.15-1.26-.25-.92.89-.15-1.23-1.1-.6 1.17-.53.16-1H8.2l.19.3L9.66.77 9 1.89 9.6 3l-1.26-.21-.92.89-.14-1.27-1.14-.6 1.17-.54.09-.53H0v18.94c2.62-3 9.79-10.19 20.64-12.11C28.73 6.14 33.3 3.1 35.72.78z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        d: "M6.22 36.47z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#222e59",
                        d: "M6.22 36.47zM22.45 35.13c.2-.78.39-1.53.59-2.28.12-.44.27-.88.39-1.32a.24.24 0 01.27-.19c.24 0 .48 0 .73-.05a2.06 2.06 0 01.26 0 .3.3 0 01.29.17h.16a4 4 0 001.52-.46l-.1-.17a9.13 9.13 0 01.85-.58 1.53 1.53 0 01.59-.05 3 3 0 000-1.27c-.06-.18-.24-.33-.32-.51-.19-.38-.07-.61.34-.72a.55.55 0 00.38-.8l-.11-.22.19-.21a.6.6 0 00.07-.72 3.47 3.47 0 01-.24-.73c0-.18 0-.27.23-.32a1.79 1.79 0 00.61-.28.73.73 0 00.17-1 5 5 0 00-.49-.54c-.24-.26-.48-.52-.7-.8s-.46-.6-.71-.88a.76.76 0 01-.18-1c.12-.31.2-.64.33-1l.9-.33a9.91 9.91 0 002.17-1.24c.42-.31.41-.71 0-.94s-1.2-.54-1.8-.82a.47.47 0 01-.24-.24 8.87 8.87 0 00-7.12-6 10.8 10.8 0 00-1.89-.16 11.89 11.89 0 00-9.31 4.39 10.37 10.37 0 00-1.32 9.44 7.79 7.79 0 01.39 2.54.61.61 0 00.15.37 2.26 2.26 0 001.73.77 2.93 2.93 0 00.58-.06c.25-.05.51-.07.82-.11.17.74.33 1.45.48 2.16h-.32c-.15 0-.17.08-.25.33-.35 1.13-.69 2.27-1 3.4a.66.66 0 01-.25.34 48.86 48.86 0 00-4.9 3.5h18c0-.21 0-.42.08-.63z"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var logo = (CampLejeuneApplicationLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/campLejeuneApplicationWrapper.tsx










const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function CampLejeuneApplicationWrapper({ children , footerBgColor  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { query  } = (0,router.useRouter)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Camp Lejeune Application",
                    domain: "CampLejeuneApplication.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Camp Lejeune Application",
                    domain: "CampLejeuneApplication.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                className: query.ts ? "withTS" : "withoutTS",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "You Deserve the Best Compensation for Camp Lejeune Water Contamination",
                        textColor: (camplejeuneapplicationVariables_module_default()).offerCallNumber,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        bgColor: footerBgColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 4420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"darkBlue":"#222e59","hover":"#fff5f5","darkRed":"#ae332f","grey":"#eaeaea","stickTitleColor":"#000","stickBtnTxtColor":"#fff","stickBtnBgColor":"#ae332f","stickBtnBorderColor":"#ae332f"};

/***/ })

}]);